import React, {createContext, useEffect, useState} from 'react';
import {getMyCompanyAuth} from "../app/common/api/WebApi";

export const CompanyContext = createContext({
  company: {},
  displayLocation: '',
  refreshContext: true
});

export const CompanyProvider = (props) => {
  const [context, setContext] = useState({
    company: {},
    displayLocation: '',
    refreshContext: true,
  });

  const getDisplayLocation = (company) => {
    return `${company?.address1}, ${company.city}`
  }
  useEffect(() => {
    if (context.refreshContext) {
      getMyCompanyAuth().then(resp => {
        let _resp = {...resp};
        let displayLocation = getDisplayLocation(resp);
        setContext({...context, company: _resp, displayLocation: displayLocation, refreshContext: false});
      });
    }
  }, [context.refreshContext]);

  return (
    <CompanyContext.Provider value={[context, setContext]}>
      {props.children}
    </CompanyContext.Provider>
  )
}